// @flow
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import type {QueryBuilder} from '@albert-io/json-api-framework/request/builder/legacy';

export function getTopicQuery({
  studentId,
  attemptNumber,
  selectedSubjects,
  startDate,
  endDate
}: {
  studentId: string,
  attemptNumber: number,
  selectedSubjects: List<string>,
  startDate: string,
  endDate: string
}): QueryBuilder {
  return mandarkEndpoint(['guide_levels_v2'])
    .meta({
      context: {
        start_date: startDate,
        end_date: endDate
      }
    })
    .meta({
      context: {
        student: {
          id: studentId
        }
      }
    })
    .meta(
      {
        context: {
          guess: {attempt_number: attemptNumber}
        }
      },
      attemptNumber
    )
    .meta(
      {
        context: {
          guess: {
            most_recent: true
          }
        }
      },
      !attemptNumber
    )
    .filter(
      {
        subject_v2: selectedSubjects.join(','),
        'meta.student_count_of_guesses': {
          not: 0
        }
      },
      !selectedSubjects.isEmpty()
    )
    .pageSize(400);
}
